document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGalleryThumbs();
  initCompare();
  initPacks();
  initFaq();
});

function initReveal() {
  var els = document.querySelectorAll('.lt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('lt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('lt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initGalleryThumbs() {
  document.querySelectorAll('[data-lt-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-lt-main-media]');
    var thumbs = gallery.querySelectorAll('[data-lt-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        var type = thumb.getAttribute('data-type');
        if (!src) return;
        if (type === 'video') {
          main.innerHTML = '<video src="' + src + '" autoplay muted loop playsinline></video>';
        } else {
          main.innerHTML = '<img src="' + src + '" alt="" loading="eager">';
        }
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });
}

function initCompare() {
  document.querySelectorAll('[data-lt-compare]').forEach(function (el) {
    var after = el.querySelector('[data-lt-compare-after]');
    var handle = el.querySelector('[data-lt-compare-handle]');
    if (!after || !handle) return;
    var dragging = false;
    function setPct(clientX) {
      var rect = el.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      after.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
    }
    el.addEventListener('pointerdown', function (e) { dragging = true; el.setPointerCapture(e.pointerId); setPct(e.clientX); });
    el.addEventListener('pointermove', function (e) { if (dragging) setPct(e.clientX); });
    el.addEventListener('pointerup', function () { dragging = false; });
    el.addEventListener('pointerleave', function () { dragging = false; });
  });
}

function initPacks() {
  document.querySelectorAll('[data-lt-producto]').forEach(function (form) {
    var packs = form.querySelectorAll('[data-lt-pack]');
    var variantInput = form.querySelector('[data-lt-variant-id]');
    var priceEl = form.querySelector('[data-lt-price]');
    var comparePriceEl = form.querySelector('[data-lt-compare-price]');
    var submitBtn = form.querySelector('[data-lt-submit]');
    if (!packs.length) return;

    packs.forEach(function (pack) {
      pack.addEventListener('click', function () {
        packs.forEach(function (p) { p.classList.remove('is-selected'); });
        pack.classList.add('is-selected');

        var variantId = pack.getAttribute('data-variant-id');
        var available = pack.getAttribute('data-available') === 'true';
        var price = pack.getAttribute('data-price');
        var comparePrice = pack.getAttribute('data-compare-price');

        if (variantInput) variantInput.value = variantId;
        if (priceEl && price) priceEl.textContent = price;
        if (comparePriceEl) {
          if (comparePrice) {
            comparePriceEl.textContent = comparePrice;
            comparePriceEl.style.display = '';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }
        if (submitBtn) submitBtn.disabled = !available;
      });
    });
  });
}

function initFaq() {
  document.querySelectorAll('[data-lt-faq-item]').forEach(function (item) {
    var question = item.querySelector('[data-lt-faq-question]');
    if (!question) return;
    question.addEventListener('click', function () {
      var wasOpen = item.classList.contains('is-open');
      item.closest('[data-lt-faq]').querySelectorAll('[data-lt-faq-item]').forEach(function (i) {
        i.classList.remove('is-open');
      });
      if (!wasOpen) item.classList.add('is-open');
    });
  });
}
